import { render, staticRenderFns } from "./ListFlowruns.vue?vue&type=template&id=2b9716ac&scoped=true&"
import script from "./ListFlowruns.vue?vue&type=script&lang=js&"
export * from "./ListFlowruns.vue?vue&type=script&lang=js&"
import style0 from "./ListFlowruns.vue?vue&type=style&index=0&id=2b9716ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9716ac",
  null
  
)

export default component.exports